<template>
  <vue-agile
    v-if="images.length"
    class="cover-agile"
    :autoplay="true"
    :dots="false"
    :infinite="true"
    :fade="true"
    :autoplay-speed="5000"
    :nav-buttons="false"
  >
    <div
      v-for="(item,index) of images"
      :key="index"
      class="cover-agile-item"
      :style="'background-image:url('+$processImage(item.url,{resize:'lg'})+')'"
    ></div>
  </vue-agile>
</template>
<script>
import { VueAgile } from 'vue-agile'
export default {
  components: {
    VueAgile,
  },
  props: {
    images: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {

    }
  }
}

</script>
<style scoped lang="scss">
.cover-agile {
  height: 410px;
  width: 100%;
  margin-bottom: 20px;

  .cover-agile-item {
    height: 410px;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}

@media (max-width: 767px) {
  .cover-agile {
    height: 260px;
    margin-bottom: 0;

    .cover-agile-item {
      height: 260px;
    }
  }
}
</style>
